/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs */

const en_admin_dashboard_invoice_tags_drop_in_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-in Passes`)
};

const de_admin_dashboard_invoice_tags_drop_in_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-in-Pässe`)
};

const es_admin_dashboard_invoice_tags_drop_in_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pases drop-in`)
};

const fr_admin_dashboard_invoice_tags_drop_in_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass drop-in`)
};

const nl_admin_dashboard_invoice_tags_drop_in_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-in-passen`)
};

const it_admin_dashboard_invoice_tags_drop_in_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass drop-in`)
};

const pt_br2_admin_dashboard_invoice_tags_drop_in_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passes avulsos`)
};

const pl_admin_dashboard_invoice_tags_drop_in_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karnety drop-in`)
};

const hu_admin_dashboard_invoice_tags_drop_in_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drop-in bérletek`)
};

const ro_admin_dashboard_invoice_tags_drop_in_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pase Drop-in`)
};

/**
* | output |
* | --- |
* | "Drop-in Passes" |
*
* @param {Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoice_tags_drop_in_pass = /** @type {((inputs?: Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoice_Tags_Drop_In_PassInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoice_tags_drop_in_pass(inputs)
	if (locale === "de") return de_admin_dashboard_invoice_tags_drop_in_pass(inputs)
	if (locale === "es") return es_admin_dashboard_invoice_tags_drop_in_pass(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoice_tags_drop_in_pass(inputs)
	if (locale === "nl") return nl_admin_dashboard_invoice_tags_drop_in_pass(inputs)
	if (locale === "it") return it_admin_dashboard_invoice_tags_drop_in_pass(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoice_tags_drop_in_pass(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoice_tags_drop_in_pass(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoice_tags_drop_in_pass(inputs)
	return ro_admin_dashboard_invoice_tags_drop_in_pass(inputs)
});
export { admin_dashboard_invoice_tags_drop_in_pass as "admin.dashboard.invoice_tags.drop_in_pass" }